export const NAME = 'campaignSettings-campaignDetail';
export const CONTACT_DATA_PRINT_COLUMN_ID = 'PRINT';
export const MAX_CONTACT_DATA_COLUMNS = 5;
